import React, { Fragment } from 'react';
import moment from 'moment';
import { Item, List, Divider, Label, Button, Feed } from 'semantic-ui-react';

const View = ({
  createdAt,
  updatedAt,
  pnr,
  token,
  source,
  onMarkAsEligible,
  onMarkAsIneligible,
  unclaimableBy,
  unclaimableAt,
  widgetCommentFromPax,
  paxName
}) => (
  <Item>
    <Item.Content>
      <Item.Header>Ticket Information</Item.Header>
      <Item.Description>
        <List>
          <List.Item>
            <List.Content>
              created: {moment(createdAt).format('DD/MM/YYYY')}
            </List.Content>
          </List.Item>
          <List.Item>
            <List.Content>
              updated: {moment(updatedAt).format('DD/MM/YYYY')}
            </List.Content>
          </List.Item>
          <List.Item>
            <List.Content>PNR: {pnr}</List.Content>
          </List.Item>
          <List.Item>
            <List.Content>Secret Token: {token}</List.Content>
          </List.Item>
          <List.Item>
            <List.Content>Source: {source}</List.Content>
          </List.Item>
          <List.Content>
            <List.Item>
              <List.Content>
                {unclaimableBy ? (
                  <Fragment>
                    <Label basic color="red">
                      {' '}
                      Ineligible{' '}
                    </Label>
                    marked by: {unclaimableBy.name} {unclaimableBy.surname},{' '}
                    {unclaimableBy.email}, at{' '}
                    {moment
                      .utc(unclaimableAt)
                      .local()
                      .format('L LT')}
                    <br />
                    <Divider hidden fitted />
                    <Button
                      color="blue"
                      size="mini"
                      onClick={onMarkAsEligible}
                      content="Mark as Eligible"
                    />
                  </Fragment>
                ) : (
                  <Button
                    color="blue"
                    size="mini"
                    onClick={onMarkAsIneligible}
                    content="Mark as Ineligible"
                  />
                )}
                {widgetCommentFromPax && (
                  <Feed>
                    <Feed.Event key={-2}>
                      <Feed.Content>
                        <Label>
                          <Feed.Summary>
                            <Feed.User>{`PAX: ${paxName}`}</Feed.User>
                            <Feed.Date>comment from widget</Feed.Date>
                          </Feed.Summary>
                          <Feed.Extra text>
                            {widgetCommentFromPax}
                          </Feed.Extra>
                        </Label>
                      </Feed.Content>
                    </Feed.Event>
                  </Feed>
                )}
              </List.Content>
            </List.Item>
          </List.Content>
        </List>
      </Item.Description>
    </Item.Content>
  </Item>
);

export default View;



// WEBPACK FOOTER //
// ./src/component/TicketPage/TicketInformation/View.js